import "./_swap-details-modal-pair-asset.scss";

import AssetLogo from "../../../../asset/logo/AssetLogo";
import DollarValue from "../../../../component/dollar-value/DollarValue";
import Typography from "../../../../component/typography/Typography";
import {SimpleAsset} from "../../../../asset/util/assetModels";

interface SwapPriceDetailsModalPairAssetProps {
  asset: SimpleAsset;
  amount: number;
}

function SwapPriceDetailsModalPairAsset({
  asset,
  amount
}: SwapPriceDetailsModalPairAssetProps) {
  return (
    <div className={"swap-details-modal-pair-asset"}>
      <AssetLogo
        asset={asset}
        size={24}
        customClassName={"swap-details-modal-pair-asset__logo"}
      />

      <DollarValue
        variant={"body"}
        fontWeight={"medium"}
        customClassName={"swap-details-modal-pair-asset__dollar-amount"}
        assetID={asset.id}
        balance={amount}
      />

      <Typography
        variant={"caption"}
        textColor={"text-gray"}
        customClassName={"swap-details-modal-pair-asset__amount"}>
        {amount} {asset.unit_name}
      </Typography>
    </div>
  );
}

export default SwapPriceDetailsModalPairAsset;
